import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import api from '../services/api';

export default function Impressum() {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getPublicLayout('impressum')
      .then(d => {
        if (d && !d.fallback && d.layout?.layout_json?.fields?.content) {
          setContent(d.layout.layout_json.fields.content);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: '60px 24px', fontFamily: "'Inter', sans-serif", color: 'var(--text-dark)', lineHeight: 1.75 }}>
      <Link to="/" style={{ color: 'var(--accent-saffron)', textDecoration: 'none', fontSize: '.88rem' }}>← Zurück zur Startseite</Link>
      <h1 style={{ fontFamily: "'Playfair Display', serif", marginTop: 32, marginBottom: 8 }}>Impressum</h1>
      <p style={{ color: 'var(--text-light)', fontSize: '.85rem', marginBottom: 40 }}>Angaben gemäß § 5 ECG (Österreich)</p>

      {loading ? (
        <div style={{ color: 'var(--text-light)', fontSize: '.88rem' }}>Lade…</div>
      ) : content ? (
        <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />
      ) : (
        <>
          <h2 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: 4 }}>Betreiber</h2>
          <p style={{ margin: '0 0 24px', color: 'var(--text-mid)' }}>
            [Vollständiger Name]<br />
            [Straße + Hausnummer]<br />
            [PLZ Ort], Österreich<br />
            E-Mail: [kontakt@domain.at]
          </p>
          <h2 style={{ fontSize: '1rem', fontWeight: 700, marginBottom: 4 }}>Haftungsausschluss</h2>
          <p style={{ color: 'var(--text-mid)', marginBottom: 24 }}>
            Die Inhalte dieser Website wurden sorgfältig erstellt. Für die Richtigkeit, Vollständigkeit
            und Aktualität der Inhalte können wir keine Gewähr übernehmen.
          </p>
          <div style={{ padding: '16px 20px', background: 'color-mix(in srgb, var(--accent-saffron) 12%, var(--surface))', borderRadius: 8, fontSize: '.85rem', color: 'var(--accent-saffron)', border: '1px solid var(--accent-saffron)' }}>
            ⚠️ Platzhalter — bitte im Admin unter Seiten → Impressum → Inhalt bearbeiten.
          </div>
        </>
      )}
    </div>
  );
}
